import React, { memo } from "react";
import { Gastronomy } from "models";
import shortUuid from "short-uuid";

interface Props {
  gastronomy: Gastronomy;
}

const GastronomyCard = ({ gastronomy }: Props) => {
  return (
    <a
      className="flex flex-col justify-between m-8 rounded shadow-lg"
      href={`https://app.gets.by?g=${shortUuid().fromUUID(gastronomy.uuid)}`}
      style={{ minWidth: "25rem" }}
    >
      <div
        className="flex w-full h-40 overflow-hidden bg-cover rounded-t"
        style={{
          backgroundImage: `url(${gastronomy.header_image})`,
          backgroundPosition: "center",
        }}
      />
      <div className="flex flex-col justify-between p-4 leading-normal bg-white rounded">
        <div className="flex items-center mb-8">
          <img
            className="w-10 h-10 mr-4 rounded-full"
            src={gastronomy.logo_image}
            alt=""
          />
          <div>
            <div className="text-xl font-bold text-gray-800">
              {gastronomy.name}
            </div>
            <p className="text-base text-gray-600">{gastronomy.type}</p>
          </div>
        </div>
        <div className="flex">
          <div className="text-sm">
            <p className="mb-1 leading-none text-gray-800">
              {gastronomy.street}
            </p>
            <p className="mb-2 leading-none text-gray-800">
              {gastronomy.zip} {gastronomy.city}
            </p>
            {gastronomy.options.coming_soon ? (
              <p className="font-bold text-blue-600">Coming Soon</p>
            ) : (
              <React.Fragment>
                {gastronomy.isOpen ? (
                  <p className="font-bold text-green-600">Jetzt geöffnet</p>
                ) : (
                  <p className="font-bold text-red-600">Geschlossen</p>
                )}
              </React.Fragment>
            )}
          </div>
        </div>
        <div className="flex flex-wrap items-start pt-8">
          {gastronomy.options.hasTableOrder && (
            <span className="inline-block px-3 py-1 mb-2 mr-2 text-sm font-semibold text-gray-700 bg-gray-200 rounded-full">
              Tischservice
            </span>
          )}
          {(gastronomy.options.hasTakeAway ||
            gastronomy.options.hasSelfService) && (
            <span className="inline-block px-3 py-1 mb-2 mr-2 text-sm font-semibold text-gray-700 bg-gray-200 rounded-full">
              Take-Away
            </span>
          )}
          {gastronomy.options.hasDelivery && (
            <span className="inline-block px-3 py-1 mb-2 mr-2 text-sm font-semibold text-gray-700 bg-gray-200 rounded-full">
              Lieferung
            </span>
          )}
          {gastronomy.options.hasDriveIn && (
            <span className="inline-block px-3 py-1 mb-2 mr-2 text-sm font-semibold text-gray-700 bg-gray-200 rounded-full">
              Drive-In
            </span>
          )}
          {gastronomy.options.hasReservation && (
            <span className="inline-block px-3 py-1 mb-2 mr-2 text-sm font-semibold text-gray-700 bg-gray-200 rounded-full">
              Reservierung
            </span>
          )}
        </div>
      </div>
    </a>
  );
};

export default memo(GastronomyCard);
